<template>
  <!-- 受限名单多选：不走全量通讯录，仅从传入 options 勾选。创建于 2026-09-22 -->
  <el-dialog
    :title="title || '选择人员'"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    append-to-body
    destroy-on-close
    width="560px"
    top="12vh"
    custom-class="flat-person-multi-dialog"
    @open="onOpen"
  >
    <div v-if="hint" class="fpm-hint">{{ hint }}</div>
    <div class="fpm-toolbar">
      <el-input
        v-model="keyword"
        clearable
        size="small"
        prefix-icon="el-icon-search"
        placeholder="搜索姓名"
        class="fpm-search"
      />
      <el-button size="small" :disabled="!filteredOptions.length" @click="selectAllFiltered">全选当前</el-button>
      <el-button size="small" type="text" :disabled="!pendingIds.length" @click="clearAll">清空</el-button>
    </div>
    <div class="fpm-meta">已选 <strong>{{ pendingIds.length }}</strong> / {{ options.length }} 人</div>
    <div class="fpm-list" v-loading="loading">
      <el-checkbox-group v-model="pendingIds" v-if="filteredOptions.length" class="fpm-grid">
        <el-checkbox
          v-for="item in filteredOptions"
          :key="String(item.value)"
          :label="String(item.value)"
          :title="item.label"
          class="fpm-item"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div v-else class="fpm-empty">{{ emptyText || '暂无可选人员' }}</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定（{{ pendingIds.length }}）</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FlatPersonMultiPickerDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    hint: { type: String, default: '' },
    emptyText: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    /** [{ value, label }] */
    options: { type: Array, default: () => [] },
    /** 已选 value 列表 */
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      keyword: '',
      pendingIds: [],
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
    filteredOptions() {
      const key = (this.keyword || '').trim().toLowerCase()
      const list = Array.isArray(this.options) ? this.options : []
      if (!key) return list
      return list.filter((item) => String(item.label || '').toLowerCase().includes(key))
    },
  },
  methods: {
    onOpen() {
      this.keyword = ''
      const optionSet = new Set((this.options || []).map((o) => String(o.value)))
      this.pendingIds = (Array.isArray(this.value) ? this.value : [])
        .map((x) => String(x))
        .filter((id) => optionSet.has(id))
    },
    selectAllFiltered() {
      const next = new Set(this.pendingIds.map((x) => String(x)))
      this.filteredOptions.forEach((item) => next.add(String(item.value)))
      this.pendingIds = Array.from(next)
    },
    clearAll() {
      this.pendingIds = []
    },
    /** 确定回传已选 id 与选项明细。创建于 2026-09-22 */
    confirm() {
      const idSet = new Set(this.pendingIds.map((x) => String(x)))
      const selected = (this.options || []).filter((o) => idSet.has(String(o.value)))
      this.$emit(
        'confirm',
        selected.map((o) => String(o.value)),
        selected
      )
      this.innerVisible = false
    },
  },
}
</script>

<style scoped>
.fpm-hint {
  margin-bottom: 10px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
  background: #f8fafc;
  border-radius: 6px;
}
.fpm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.fpm-search {
  flex: 1;
}
.fpm-meta {
  margin-bottom: 8px;
  font-size: 13px;
  color: #475569;
}
.fpm-list {
  height: 280px;
  box-sizing: border-box;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
}
.fpm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(112px, 1fr));
  gap: 8px;
  align-content: start;
}
.fpm-item {
  display: flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  transition: border-color 0.15s, background-color 0.15s;
}
.fpm-item:hover {
  border-color: #93c5fd;
}
.fpm-item.is-checked {
  border-color: #409eff;
  background: #ecf5ff;
}
.fpm-item >>> .el-checkbox__label {
  min-width: 0;
  padding-left: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fpm-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 8px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
</style>

<style>
.flat-person-multi-dialog .el-dialog__body {
  padding: 12px 16px 8px;
}
</style>
